import React from 'react';
import './Trucktype.css';

const Trucktype =() => {
  return (
  <>
  <div className="container5">
   <div id="fea" className="features">
	<div className="container1">								
		<div className="section-head">
				<h2 style={{textAlign: "center"}}>
	<strong style={{fontFamily: "verdana,geneva,sansSerif", color: "rgb(6, 75, 118)", fontSize: "30px", paddingBottom:"20px"}}>Popular Truck Types</strong></h2>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>JAI HIND Transport is the leading transporter in Shimoga-karnataka, uses different types of trucks to suit different kinds of loads. We choose these trucks to do a specific type of job. Depending on their shapes and sizes, these trucks make the transportation of goods and freight easy. With the online truck booking facility available today, customers want to choose the truck of their choice depending on their needs such as type of freight and load.</span></span></span></p>
<p><hr/>
	&nbsp;</p>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif", fontSize:"larger", fontWeight:"bold"}}><strong>Importance of choosing the right type of truck</strong></span></span></span></p>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>Cost is a major concern while hiring a company. People avoid using transport services because of their high price, but there is good news. Choosing the right type of truck to ship your goods is can help to decrease the per-unit cost of transportation. JAI HIND Transport allows you to choose the right type of truck to reduce your overall moving cost.</span></span></span></p>
<p><hr/>
	&nbsp;</p>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif",fontSize:"larger", fontWeight:"bold"}}><strong>Closed Body Truck Or Container Truck</strong></span></span></span></p>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>This truck category consists of three types of container trucks or closed body trucks with varied lengths. This type of trucks is used to transport heavy loads.</span></span></span></p>
<ul>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>32 Feet Single Axel Truck (7.5 Ton Capacity)</span></span></span></li>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>32 Feet Multi Axel Truck (16 Ton Capacity)</span></span></span></li>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>24 Feet Single Axel Truck (7.5 Ton Capacity)</span></span></span></li>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>24 Feet Multi Axel Truck (16 Ton Capacity)</span></span></span></li>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>20 Feet Single Axel Truck (7.5 Ton Capacity)</span></span></span></li>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>20 Feet Multi Axel Truck (16 Ton Capacity)</span></span></span></li>
</ul><hr/>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif",fontSize:"larger", fontWeight:"bold"}}><strong>Heavy Open Body Trucks</strong></span></span></span></p>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>This segment of a truck involves three types of trucks with different sizes which are suitable for the transportation of chemicals, food grains, raw materials and other heavy goods.</span></span></span></p>
<ul>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>32-40 Feet 14 Wheeler Truck (21 Ton To 31 Ton Capacity)</span></span></span></li>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>20-32 Feet 10 Wheeler Truck (10 Ton To 25 Ton Capacity)</span></span></span></li>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>24-32 Feet 12 Wheeler Truck (16 Ton To 25 Ton Capacity)</span></span></span></li>
</ul><hr/>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif",fontSize:"larger", fontWeight:"bold"}}><strong>Light Open Body Truck</strong></span></span></span></p>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>This category has three types of trucks with different capacities and is used for bulky boxes containing light items. We use-</span></span></span></p>
<ul>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>14 Feet Eicher (Capacity Of 3.5 - 4 Ton Capacity)</span></span></span></li>
	<li>
		<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>20 Feet Eicher (Capacity Of 4.5 - 5 Ton Capacity)</span></span></span></li>
	<li>
		<span style={{color: "rgb(6, 75, 118)"}}><span style={{fontSize: "16px"}}><span style={{fontFamily: "verdana, geneva, sans-serif"}}>19 Feet Eicher (Capacity Of 5.5 - 10 Ton Capacity)</span></span></span></li>
</ul><hr/>
<p>
	<span style={{color:"#064b76"}}><span style={{fontSize:"16px"}}><span style={{fontFamily:"verdana,geneva,sans-serif"}}>We, at JAI HIND Transport , are trying to resolve the problems that businesses and people experience in transporting their goods due to the lack of professional transporter in India. We help to minimize the cost of transportation by offering you a wide range of trucks. We enable you to move to any part of the country without any transportation problem.</span></span></span></p>
	<hr/> <center>Vehicle Dimensions (approx) and Max Load Capacity. ( Size differ as per Make Model of Manufacturer &amp; Custom Modifications )</center>

		</div>
	</div>
</div><br></br>
<table border="2" cellpadding="0" cellspacing="0" rules="all" className="bodytext ml20" align="center">
        <colgroup>
		<col width="330" style={{width:"330pt"}}/>
        <col width="167" style={{width:"125pt"}}/>
        <col width="367" style={{width:"275pt"}}/>
        </colgroup>

		<tbody><tr style={{height:"20.0pt"}}>
          <th className="excel2" width="160" style={{height:"20.0pt,width:255pt"}}>TRUCK TYPE </th>
          <th className="excel2" width="167" style={{borderLeft:"none,width:295pt"}}> SIZE (FT)  </th>
		  <th className="excel2" width="367" style={{borderLeft:"none,width:255pt"}}>HOUSE HOLD CAPACITY</th>
          <th className="excel2" width="367" style={{borderLeft:"none,width:255pt"}}>MAX WEIGHT</th>
		  
        </tr>
		<tr style={{height:"20.0pt"}}>    
		  <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>TATA ACE</td>
        <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>7 L x 4.8 W x 4.8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>1 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 850 Kgs</td>
        </tr>
		<tr style={{height:"20.0pt"}}>         
		<td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>ASHOK LEYLAND DOST</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>7 L x 4.8 W x 4.8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>1 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 1 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>        
		 <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>MAHINDRA BOLERO PICK UP</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>8 L x 4.8 W x 4.8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>1 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 1.5 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>         
		<td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>TATA 407</td>
        <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>9 L x 5.5 W x 5 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>1.5 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 2.5 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>      
		  <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>EICHER 14 FEET</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>14 L x 6 W x 6.5 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>2 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 4 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>         
		 <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>EICHER 20 FEET</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>20 L x 6 W x 7 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>2.5 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 5 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>       
		  <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>EICHER 19 FEET</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>19 L x 7 W x 7 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>2.5 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 7/8/9 Ton</td>
         </tr>
		 
		 <tr style={{height:"20.0pt"}}>        
		  <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>TATA 22 FEET</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>22 L x 7.5 W x 7 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>3 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 10 Ton</td>
         </tr>
		 <tr style={{height:"20.0pt"}}>        
		  <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>TATA TRUCK (6 TYRE)</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>20.5 L x 7 W x 7 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 9 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>       
		 <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>TAURUS 16 T (10 TYRE)</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>21 L x 7.2 W x 7 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 16 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>        
		<td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>TAURUS 21 T (12 TYRE)</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}> 24 L x 7.3 W x 7 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 21 Ton</td>
        </tr>
    	<tr style={{height:"20.0pt"}}>
          <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>TAURUS 25 T (14 TYRE)</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}> 28 L x 7.8 W x 7 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 25 Ton</td>
        </tr>		  
		<tr style={{height:"20.0pt"}}>
          <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>CONTAINER 20 FT</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>20 L x 8 W x 8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>4 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 6.5 Ton</td>
       </tr>
	   <tr style={{height:"20.0pt"}}>
          <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>CONTAINER 32 FT SXL</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>32 L x 8 W x 8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>5 BHK</td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 7 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>
          <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>CONTAINER 32 FT MXL</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>32 L x 8 W x 8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 14 Ton</td>
        </tr>		
		<tr style={{height:"20.0pt"}}>
          <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>CONTAINER 32 FT SXL / MXL HQ</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>32 L x 8 W x 10 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 7 / 14 Ton</td>
        </tr>		
		<tr style={{height:"20.0pt"}}>
          <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>20 FEET OPEN ALL SIDE (ODC)</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>20 L x 8 W x 8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 7 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>
          <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>28-32 FEET OPEN-TRAILOR JCB ODC</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}> 28-32 L X 8 W x 8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 8 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>
          <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>32 FLT OPEN-TAILOR ODC</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}> 32 L X 8 W x 8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 25 Ton</td>
        </tr>
		<tr style={{height:"20.0pt"}}>
          <td className="excel2" style={{height:"20.0pt",borderTop:"none"}}>40 FEET OPEN-TRAILOR ODC</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>40 L X 8 W x 8 H</td>
          <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}></td>
		  <td className="excel2" style={{borderTop:"none",borderLeft:"none"}}>Max Load 32 Ton</td>
        </tr>
      </tbody></table>

      <div id="fea" className="features payment">
	<div className="container col-xs-3" id="type1" style={{maxWidth:"90%"}}>
	<div className="section-head text-center">
			<h3 className={{color:" #064b76"}}style={{fontSize:"2.5em"}}>Popular Truck Types</h3>
		</div>
			<div className="row col-md-12 payment-option" style={{justifyContent:"center"}}>
			{/* <div className="row"> */}
				
				<div className="col-md-2" id="border" style={{marginRight:"7.5px",marginLeft:"7.5px",marginBottom:"15px"}}>
					<div className="center">
						<img src="tataace.jpg" alt="img" style={{width:'189px',height:'160px'}}/>
					</div>
					<div className="center">									
						<h4 style={{marginTop: "100px !important", paddingTop: '30px', fontSize:'20px'}}><b>TATA ACE</b></h4>
						<p>Max Load 850 Kgs</p>
					</div>
				</div>
				
				<div className="col-md-2" id="border" style={{marginRight:"7.5px",marginLeft:"7.5px",marginBottom:"15px"}}>
					<div className="center">
						<img src="eicher-19feet.jpg" alt="img" style={{width:'189px',height:'160px'}}/>
					</div>
					<div className="center">
						<h4 style={{marginTop: "40px !important",paddingTop: '30px', fontSize:'20px'}}><b>EICHER 19</b></h4>
						<p>Max Load 7 Ton</p>
					</div>
				</div>	
				
				<div className="col-md-2" id="border" style={{marginRight:"7.5px",marginLeft:"7.5px",marginBottom:"15px"}}>
					<div className="center">
						<img src="taurus-21ton.jpg" alt="img" style={{width:'189px',height:'160px'}}/>
					</div>
					<div className="center">
						<h4 style={{marginTop: "68px !important",paddingTop: '30px', fontSize:'20px'}}><b>TATA TAURUS 21 T</b></h4>
						<p>Max Load 21 Ton</p>
					</div>
				</div>
				<div className="col-md-2" id="border" style={{marginRight:"7.5px",marginLeft:"7.5px",marginBottom:"15px"}}>
					<div className="center">
						<img src="container-32feet.jpg" alt="img" style={{width:'189px',height:'160px'}}/>
					</div>
					<div className="center">
						<h4 style={{marginTop: "60px !important", paddingTop: '30px', fontSize:'20px'}}><b>CONTAINER 32 FT SXL</b></h4>
						<p>Max Load 7 Ton</p>
					</div>
				</div>
				
				<div className="col-md-2" id="border" style={{marginRight:"7.5px",marginLeft:"7.5px",marginBottom:"15px"}}>
					<div className="center">
						<img src="platform-trailor.jpg" alt="img" style={{width:'189px',height:'160px'}}/>
					</div>
					<div className="center">
						<h4 style={{marginTop: "65px !important", paddingTop: '30px', fontSize:'20px'}}><b>40 FEET OPEN-TRAILOR</b></h4>
						<p>Max Load 32 Ton</p>
					</div>
				</div>
			</div>
	</div>
</div>

</div>

</>
);
}; 
  export default Trucktype;